<script setup lang="ts">
import type { Timeframe } from '#core/types/date-filter'
import { useLeaderboardStore } from '#leaderboards/store/useLeaderboardStore'
import { TimeframePicker } from '@forgd/ui-kit/blocks/timeframe-picker'
import { Button } from '@forgd/ui-kit/button'
import { Card, CardContent } from '@forgd/ui-kit/card'
import { Label } from '@forgd/ui-kit/label'
import { Sheet, SheetBody, SheetClose, SheetContent, SheetHeader, SheetTitle } from '@forgd/ui-kit/sheet'
import { Switch } from '@forgd/ui-kit/switch'
import { AdjustmentsHorizontalIcon, XMarkIcon } from '@heroicons/vue/24/outline'

const store = useLeaderboardStore()

const applyGloballyId = useId()

onUnmounted(() => {
  store.isFilterSlideoverOpen = false
})

const timeframeOptions: { label: string, value: Exclude<Timeframe, '24h'> | 'all' }[] = [
  { label: 'All Time', value: 'all' },
  { label: 'Prev. 7d', value: '7d' },
  { label: 'Prev. 30d', value: '30d' },
  { label: 'Prev. 60d', value: '60d' },
]
</script>

<template>
  <Sheet :open="store.isFilterSlideoverOpen" :modal="false" @update:open="(open) => !open && (store.isFilterSlideoverOpen = false)">
    <SheetContent
      side="right"
      size="xs"
      :overlay="false"
      data-ui="Sheet"
      @interact-outside="(e) => e.preventDefault()"
    >
      <SheetHeader>
        <div class="flex items-center gap-2 text-sm">
          <AdjustmentsHorizontalIcon class="size-4 shrink-0" aria-hidden="true" />
          <SheetTitle class="font-semibold">
            Refine Leaderboard
          </SheetTitle>
        </div>
        <SheetClose as-child>
          <Button type="button" size="sm" variant="ghost" icon-only aria-label="Close" data-testid="close-slideover-button">
            <XMarkIcon />
          </Button>
        </SheetClose>
      </SheetHeader>

      <SheetBody>
        <p class="text-sm text-gray-600">
          Select the parameters to view the market maker rankings with a more detailed view.
        </p>
        <div class="flex items-center justify-between bg-neutral-400 p-2 rounded-lg">
          <Label :for="applyGloballyId" class="text-xs font-semibold">Apply preferences to all leaderboards</Label>
          <Switch :id="applyGloballyId" v-model="store.applyFiltersGlobally" size="lg" />
        </div>

        <Card>
          <CardContent>
            <h3 class="text-sm font-semibold text-primary-900">
              Timeframe
            </h3>
            <TimeframePicker
              v-model="store.filterState.timeframe"
              :options="timeframeOptions"
              class="mt-4"
            />
          </CardContent>
        </Card>
      </SheetBody>
    </SheetContent>
  </Sheet>
</template>
